import React from 'react';
import { AppBar, Toolbar, Typography, Button, Box, Avatar, Snackbar, Alert } from '@mui/material';
import { useAuth } from '../contexts/AuthContext';

const Header = () => {
  const { currentUser, login, logout } = useAuth();
  const [error, setError] = React.useState('');
  const [openSnackbar, setOpenSnackbar] = React.useState(false);

  const handleLogin = async () => {
    try {
      await login();
    } catch (err) {
      console.error("Login failed:", err);
      setError('Login failed: ' + (err.message || err));
      setOpenSnackbar(true);
    }
  };

  const handleCloseSnackbar = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpenSnackbar(false);
  };

  return (
    <AppBar position="static">
      <Toolbar>
        <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
          Pitch Counter
        </Typography>
        {currentUser ? (
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <Avatar
              src={currentUser.photoURL}
              alt={currentUser.email}
              sx={{ width: 32, height: 32, mr: 2, bgcolor: 'secondary.main' }}
            >
              {!currentUser.photoURL && currentUser.email ? currentUser.email.charAt(0).toUpperCase() : null}
            </Avatar>
            <Button color="inherit" onClick={logout}>
              Logout
            </Button>
          </Box>
        ) : (
          <Button color="inherit" onClick={handleLogin}>
            Login
          </Button>
        )}
      </Toolbar>
      <Snackbar open={openSnackbar} autoHideDuration={6000} onClose={handleCloseSnackbar}>
        <Alert onClose={handleCloseSnackbar} severity="error" sx={{ width: '100%' }}>
          {error}
        </Alert>
      </Snackbar>
    </AppBar>
  );
};

export default Header;
